import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ServiceFAQ = ({ faqs }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-white rounded-xl shadow-elevation-2 p-8 border border-border">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-text-primary mb-2">
          Frequently Asked Questions
        </h2>
        <p className="text-text-secondary">
          Get answers to common questions about our cleaning services
        </p>
      </div>
      <div className="space-y-4">
        {faqs?.map((faq, index) => (
          <div
            key={index}
            className="border border-border rounded-lg overflow-hidden"
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-muted transition-colors duration-200"
            >
              <h3 className="font-medium text-text-primary pr-4">
                {faq?.question}
              </h3>
              <Icon
                name={openIndex === index ? "ChevronUp" : "ChevronDown"}
                size={20}
                color="var(--color-text-secondary)"
                className="flex-shrink-0"
              />
            </button>
            
            {openIndex === index && (
              <div className="px-6 pb-4">
                <div className="text-text-secondary leading-relaxed">
                  {faq?.answer}
                </div>
                
                {faq?.additionalInfo && (
                  <div className="mt-3 p-3 bg-primary/5 rounded-lg border border-primary/10">
                    <div className="flex items-start space-x-2">
                      <Icon name="Info" size={16} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
                      <div className="text-sm text-primary">
                        {faq?.additionalInfo}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
      {/* Contact for More Questions */}
      <div className="mt-8 bg-muted rounded-lg p-6 text-center">
        <h3 className="font-semibold text-text-primary mb-2">
          Still have questions?
        </h3>
        <p className="text-text-secondary mb-4">
          Our customer service team is here to help you with any additional questions.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button className="flex items-center justify-center space-x-2 px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors duration-200">
            <Icon name="Phone" size={16} />
            <span>Call (555) 123-4567</span>
          </button>
          <button className="flex items-center justify-center space-x-2 px-4 py-2 border border-border rounded-lg hover:bg-white transition-colors duration-200">
            <Icon name="MessageCircle" size={16} />
            <span>Start Live Chat</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceFAQ;